import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { getTimePeriod, updateTimePeriod, getNetImpactLabel } from "containers/Setup/reducer";
import { getStep, updateStep } from "containers/CreateWizard/reducer";

import ChooseTimePeriod from "components/CreateWizard/Costs/ChooseTimePeriod";

class ChooseTimePeriodContainer extends React.PureComponent {
  handleUpdate(sel) {
    const { index, updateTimePeriod, updateStep } = this.props;

    return updateTimePeriod(sel);
  }

  render() {
    const { step, index } = this.props;

    return <ChooseTimePeriod {...this.props} handleUpdate={(sel) => this.handleUpdate(sel)} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateStep: (step) => dispatch(updateStep(step)),
  updateTimePeriod: (timePeriod) => dispatch(updateTimePeriod(ownProps.id, timePeriod))
});

const mapStateToProps = (state, ownProps) => ({
  step: getStep(state),
  timePeriod: getTimePeriod(state, ownProps.id),
  netImpactLabel: getNetImpactLabel(state, ownProps.id)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(ChooseTimePeriodContainer);
